import dayjs from '@/plugins/dayjs'
import type { EmailTemplate, SmsTemplate } from '@/types/template'

export const emailTemplatesFixture: EmailTemplate[] = [
  {
    id: 'tpl_email_welcome',
    name: 'Bun venit',
    category: 'welcome' as const,
    subject: 'Vă mulțumim că sunteți alături de noi, {{first_name}}!',
    previewText: 'Suntem încântați să te avem alături.',
    updatedAt: dayjs().subtract(30, 'day').toISOString(),
    blocks: [
      { id: 'b1', type: 'title', content: 'Bine ai venit, {{first_name}}!' },
      {
        id: 'b2',
        type: 'text',
        content: 'Mulțumim că ai ales {{company}}. Suntem aici pentru orice întrebare ai avea.',
      },
      { id: 'b3', type: 'button', label: 'Vezi ofertele noastre', url: '#' },
      { id: 'b4', type: 'divider' },
      { id: 'b5', type: 'footer', text: 'Ai primit acest email deoarece ești clientul {{company}}.' },
    ],
  },
  {
    id: 'tpl_email_promo',
    name: 'Ofertă promoțională',
    category: 'promo' as const,
    subject: 'Ofertă specială doar pentru dvs.',
    updatedAt: dayjs().subtract(10, 'day').toISOString(),
    blocks: [
      { id: 'b1', type: 'title', content: 'O ofertă specială pentru tine, {{first_name}}' },
      { id: 'b2', type: 'text', content: 'Profită de reducerea noastră limitată în timp.' },
      { id: 'b3', type: 'button', label: 'Vezi oferta', url: '#' },
      { id: 'b4', type: 'footer', text: '{{company}} · Poți renunța oricând la aceste comunicări.' },
    ],
  },
  {
    id: 'tpl_email_reminder',
    name: 'Reamintire programare',
    category: 'reminder' as const,
    subject: 'Confirmare programare',
    updatedAt: dayjs().subtract(5, 'day').toISOString(),
    blocks: [
      { id: 'b1', type: 'title', content: 'Reamintire programare' },
      { id: 'b2', type: 'text', content: 'Salut {{first_name}}, îți reamintim de programarea de mâine.' },
      { id: 'b3', type: 'footer', text: '{{company}}' },
    ],
  },
]

export const smsTemplatesFixture: SmsTemplate[] = [
  {
    id: 'tpl_sms_welcome',
    name: 'Bun venit',
    category: 'welcome' as const,
    content: 'Bună, {{first_name}}! Mulțumim că ai ales {{company}}.',
    updatedAt: dayjs().subtract(20, 'day').toISOString(),
  },
  {
    id: 'tpl_sms_reminder',
    name: 'Reamintire programare',
    category: 'reminder' as const,
    content: 'Bună {{first_name}}, aveți o programare mâine la ora 10:00 la {{company}}. Răspundeți CONFIRM.',
    updatedAt: dayjs().subtract(8, 'day').toISOString(),
  },
  {
    id: 'tpl_sms_promo',
    name: 'Promoție',
    category: 'promo' as const,
    content: 'Salut, {{first_name}}! Avem o ofertă specială pentru tine, valabilă doar azi.',
    updatedAt: dayjs().subtract(3, 'day').toISOString(),
  },
]
